import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";
import { queryClient } from "~/lib/query-client";
import { creditsBalanceQuery } from "~/modules/credits/network/queries";

import { getCheckoutInfoResponseSchema, stripeKeyModeEnumSchema } from "./schema";

export const getCheckoutInfoQuery = createQueryRequestDefinition({
  queryKey: ["checkout-info"],
  host: "cap-srv",
  path: "mirage-studio/checkout/info",
  method: "GET",
  responseSchema: getCheckoutInfoResponseSchema,
  paramsSchema: z.object({
    stripeKeyMode: stripeKeyModeEnumSchema,
  }),
});

export const getCreditsPaymentStatusQuery = createQueryRequestDefinition({
  queryKey: ["credits-status"],
  host: "cap-srv",
  path: "mirage-studio/checkout/get-credits-payment-status",
  method: "GET",
  paramsSchema: z.object({
    stripePaymentIntentId: z.string(),
  }),
  responseSchema: z.object({
    state: z.string(),
    quantity: z.number(),
    amountCents: z.number(),
    isOffSessionPayment: z.boolean(),
    creditsGrantedAt: z.string().nullable(),
  }),
}).withPolling({
  determinePollingStatus(result, resultCreator) {
    if (result.creditsGrantedAt) {
      return resultCreator.done(result);
    }

    return resultCreator.pending(result);
  },
  onSuccess() {
    creditsBalanceQuery.invalidateQuery(queryClient);
  },
});
